var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnpublishIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 5,
    fill: "#FFBB38"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 13.75C5.75 10.7124 8.21243 8.25 11.25 8.25C12.2526 8.25 13.1912 8.51782 13.9996 8.9855C14.2387 9.12377 14.5445 9.04209 14.6828 8.80306C14.8211 8.56403 14.7394 8.25816 14.5004 8.11989C13.5438 7.56654 12.4331 7.25 11.25 7.25C7.66015 7.25 4.75 10.1601 4.75 13.75C4.75 17.3399 7.66015 20.25 11.25 20.25C14.8399 20.25 17.75 17.3399 17.75 13.75C17.75 13.4739 17.5261 13.25 17.25 13.25C16.9739 13.25 16.75 13.4739 16.75 13.75C16.75 16.7876 14.2876 19.25 11.25 19.25C8.21243 19.25 5.75 16.7876 5.75 13.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3964 5.89645C14.5917 5.70118 14.9083 5.70118 15.1036 5.89645L17.75 8.54289L20.3964 5.89645C20.5917 5.70118 20.9083 5.70118 21.1036 5.89645C21.2988 6.09171 21.2988 6.40829 21.1036 6.60355L18.4571 9.25L21.1036 11.8964C21.2988 12.0917 21.2988 12.4083 21.1036 12.6036C20.9083 12.7988 20.5917 12.7988 20.3964 12.6036L17.75 9.95711L15.1036 12.6036C14.9083 12.7988 14.5917 12.7988 14.3964 12.6036C14.2012 12.4083 14.2012 12.0917 14.3964 11.8964L17.0429 9.25L14.3964 6.60355C14.2012 6.40829 14.2012 6.09171 14.3964 5.89645Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpublishIcon);
export default __webpack_public_path__ + "static/media/unpublish-icon.046a3dd448af1507da3f7082923088bb.svg";
export { ForwardRef as ReactComponent };